export default __webpack_public_path__ + "static/media/download-button.a012ac1f.svg";